import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Grid,
  CircularProgress,
  Typography,
  TextField,
  Box,
  makeStyles,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  IconButton,
  Checkbox,
  FormControlLabel,
  Link,
} from "@material-ui/core";

import { Visibility, VisibilityOff } from '@material-ui/icons';
import EmailIcon from "@material-ui/icons/Email";
import { getSupportEmail } from "../../utils/siteBrand";

import { ChildCareSharp } from "@material-ui/icons";

import "./login.css";
import CategoryServices from "../../services/CategoryServices";
import { loginUser } from "../../context/UserContext";
import { withRouter } from "react-router-dom";
import { useUserDispatch } from "../../context/UserContext";
// -------------------- STYLES --------------------
const useResponsiveStyles = makeStyles((theme) => ({
  container: {
    // The parent Grid's container style
    display: "flex",
  },
  mainBox: {
    // Styles for the white card area
    marginLeft: "15%",
    marginRight: "15%",
    marginTop: "3%",
    padding: "30px",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    borderRadius: "10px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    width: "100%",
    maxWidth: "1200px",
    // Media query for small screens
    [theme.breakpoints.down("sm")]: {
      marginLeft: "5%",
      marginRight: "5%",
      marginTop: "5%",
      padding: "15px",
    },
  },
  icon: {
    marginBottom: theme.spacing(1),
  },
  iconImage: {
    width: 25,
    height: "auto",
  },
  studentButton: {
    backgroundColor: "#E0ECFF", // Pastel blue
    color: "#333",
    borderRadius: theme.shape.borderRadius * 3,
    textTransform: "none",
    minWidth: 100,
    "&:hover": {
      backgroundColor: "#C7DCFF",
    },
    "&.selected": {
      backgroundColor: "#3675dcb8",
      color: "#fff",
    },
  },
  parentButton: {
    backgroundColor: "#F8E8FE", // Pastel pink
    color: "#333",
    borderRadius: theme.shape.borderRadius * 3,
    textTransform: "none",
    minWidth: 100,
    "&:hover": {
      backgroundColor: "#EDD1FD",
    },
    "&.selected": {
      backgroundColor: "#a44cd773",
      color: "#fff",
    },
  },
  teacherButton: {
    backgroundColor: "#ECFDE8", // Pastel green
    color: "#333",
    borderRadius: theme.shape.borderRadius * 3,
    textTransform: "none",
    minWidth: 100,
    "&:hover": {
      backgroundColor: "#D8FBCF",
    },
    "&.selected": {
      backgroundColor: "#6ae04e",
      color: "#fff",
    },
  },
  textFieldUnderline: {},
  textField: {},
  formButtons: {
    marginTop: theme.spacing(2),
  },
  loginLoader: {
    marginLeft: theme.spacing(2),
  },
  forgetButton: {
    marginTop: theme.spacing(1),
  },
  consentBox: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    padding: theme.spacing(1, 1.5),
    borderRadius: 8,
    backgroundColor: "#f8fafc",
    border: "1px solid #e2e8f0",
  },
  consentLabel: {
    fontSize: "0.85rem",
    color: "#334155",
    lineHeight: 1.4,
  },
}));

function Login(props) {
  const classes = useResponsiveStyles();
  const supportEmail = getSupportEmail();
  const [showPasswordDialog, setShowPasswordDialog] = useState(false);
  const [showPasswordDialogReset, setShowPasswordDialogReset] = useState(false);

  const history = useHistory();

  // global
  var userDispatch = useUserDispatch();
  // local
  var [isLoading, setIsLoading] = useState(false);
  var [error, setError] = useState(null);
  var [loginValue, setLoginValue] = useState("");
  var [passwordValue, setPasswordValue] = useState("");
  var [roleValue, setRoleValue] = useState("TEACHER");
  const [parentConsentAccepted, setParentConsentAccepted] = useState(false);
  /** True when API says this username already accepted app consent — hide checkbox. */
  const [parentConsentAlreadyGiven, setParentConsentAlreadyGiven] = useState(false);
  const [parentConsentStatusLoading, setParentConsentStatusLoading] = useState(false);
  const [ackDialogOpen, setAckDialogOpen] = useState(false);
  const [ackChecked, setAckChecked] = useState(false);
  const [ackSaving, setAckSaving] = useState(false);

  // OTP dialog states
  const [otpDialogOpen, setOtpDialogOpen] = useState(false);
  const [otpDialogOpenReset, setOtpDialogOpenReset] = useState(false);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [otpReset, setOtpReset] = useState("");
  const [newPasswordReset, setNewPasswordReset] = useState("");
  const [oldPasswordReset, setOldPasswordReset] = useState("");

  const [newPassword, setNewPassword] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpSentReset, setOtpSentReset] = useState(false);
  const [resendEnabled, setResendEnabled] = useState(false);
  const [timer, setTimer] = useState(30);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  // Role click
  const handleRoleClick = (role) => {
    setRoleValue(role);
    if (role !== "TEACHER" && role !== "SCHOOLE") {
      setOtpDialogOpen(false);
    }
    if (role !== "PARENT") {
      setParentConsentAccepted(false);
      setParentConsentAlreadyGiven(false);
    }
  };

  const finishParentLogin = () => {
    userDispatch({ type: "LOGIN_SUCCESS" });
    history.push("/app/assignment");
  };

  const openParentAcknowledgement = () => {
    setAckChecked(false);
    setAckDialogOpen(true);
  };

  const handleParentAcknowledgementContinue = async () => {
    if (!ackChecked) {
      alert("Please acknowledge access to your student's complete data to continue.");
      return;
    }
    setAckSaving(true);
    try {
      const res = await CategoryServices.acceptParentDataAcknowledgement({});
      const detail = JSON.parse(localStorage.getItem("userDetail") || "{}");
      localStorage.setItem(
        "userDetail",
        JSON.stringify({
          ...detail,
          parentDataAcknowledged: true,
          parentDataAcknowledgedAt: res?.parentDataAcknowledgedAt || new Date().toISOString(),
        }),
      );
      setAckDialogOpen(false);
      finishParentLogin();
    } catch (err) {
      alert(err?.response?.data?.message || err?.message || "Failed to save acknowledgement.");
    } finally {
      setAckSaving(false);
    }
  };

  // Lookup consent by parent username so returning parents are not asked again.
  useEffect(() => {
    if (roleValue !== "PARENT") return undefined;
    const username = String(loginValue || "").trim();
    if (!username) {
      setParentConsentAlreadyGiven(false);
      setParentConsentAccepted(false);
      return undefined;
    }
    let cancelled = false;
    const timerId = setTimeout(() => {
      setParentConsentStatusLoading(true);
      CategoryServices.getParentConsentStatus({ username, role: "PARENT" })
        .then((res) => {
          if (cancelled) return;
          const given = Boolean(res?.found && res?.parentConsentAccepted);
          setParentConsentAlreadyGiven(given);
          if (given) setParentConsentAccepted(true);
          else setParentConsentAccepted(false);
        })
        .catch(() => {
          if (cancelled) return;
          setParentConsentAlreadyGiven(false);
          setParentConsentAccepted(false);
        })
        .finally(() => {
          if (!cancelled) setParentConsentStatusLoading(false);
        });
    }, 400);
    return () => {
      cancelled = true;
      clearTimeout(timerId);
    };
  }, [loginValue, roleValue]);
  const handlePasswordChangeConfirm = () => {
    // setOtpDialogOpen(true);
    // setOtpSent(true)
    setOtpDialogOpenReset(true);

    //history.push("/change-password"); // Redirect to password reset page
  };
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (confirmPassword && e.target.value !== confirmPassword) {
      setError("Passwords do not match!");
    } else {
      setError("");
    }
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    if (password && e.target.value !== password) {
      setError("Passwords do not match!");
    } else {
      setError("");
    }
  };

  // Handle OTP Timer
  useEffect(() => {
    let interval;
    if (otpSent && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setResendEnabled(true);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [otpSent, timer]);

  const canForgotPassword = roleValue === "TEACHER" || roleValue === "SCHOOLE";
  const forgotPasswordRoleLabel = roleValue === "SCHOOLE" ? "School" : "Teacher";

  // Send OTP
  const handleSendOtp = async () => {
    try {
      await CategoryServices.forgetUserPassword({ mobile: mobile, role: roleValue });
      setOtpSent(true);
      setResendEnabled(false);
      setTimer(30);
    } catch (error) {
      console.error("Error sending OTP:", error);
    }
  };
  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  // Resend OTP
  const handleResendOtp = async () => {
    try {
      await CategoryServices.forgetUserPassword({ mobile: mobile, role: roleValue });
      setResendEnabled(false);
      setTimer(30);
    } catch (error) {
      console.error("Error resending OTP:", error);
    }
  };
  const resetDefaultPassword = async () => {
    try {
      await CategoryServices.resetDefaultPassword({ mobile: mobile });
      setResendEnabled(false);
    } catch (error) {
      console.error("Error resending OTP:", error);
    }
  }
  // Update password
  const handleUpdatePassword = async () => {
    try {
      await CategoryServices.updateUserPassword({ mobile, otp, newPassword, role: roleValue });
      alert("Password updated successfully.");
      setOtpDialogOpen(false);
      // props.history.push("/montessori/login");
    } catch (error) {
      console.error("Error updating password:", error);
    }
  };
  const handleUpdatePasswordReset = async () => {
    try {
      if (!password) {
        alert('please enter password')
        return
      }
      if (!confirmPassword) {
        alert('please enter password')
        return
      }
      if (confirmPassword !== password) {
        alert(
          'password and confim password not matching'
        )
        return
      }
      const confirmPasswords = await CategoryServices.resetDefaultPassword({ mobile: loginValue, password: confirmPassword, });
      setOtpDialogOpenReset(false);
      if (confirmPasswords.status) {
        const detail = JSON.parse(localStorage.getItem("userDetail") || "{}");
        if (!detail.parentDataAcknowledged) {
          openParentAcknowledgement();
        } else {
          finishParentLogin();
        }
      }
      // props.history.push("/montessori/login");
    } catch (error) {
      console.error("Error updating password:", error);
    }
  };
  return (
    <Grid container className={classes.container}>
      {/* Main Card Section */}
      <Box className={classes.mainBox} >
        <Grid container spacing={3} alignItems="center">
          {/* Left Side - Login Form */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h4"
              gutterBottom
              style={{ fontWeight: "bold", textAlign: "left" }}
            >
              Welcome to Montestory
            </Typography>

            {/* Role Buttons */}
            <Grid container spacing={3} alignItems="center" style={{ paddingRight: "20px" }}>
              {/* Parent Button */}
              <Grid item xs={6} sm={3}>
                <Button
                  className={`${classes.parentButton} ${roleValue === "PARENT" ? "selected" : ""
                    }`}
                  onClick={() => handleRoleClick("PARENT")}
                  data-testid="login-role-PARENT"
                >
                  <Box className={classes.icon}>
                    <img
                      src="/images/Parent icon.svg"
                      alt="Parent Icon"
                      className={classes.iconImage}
                    />
                  </Box>
                  <Typography
                    variant="body1"
                    style={{ color: "black", fontSize: "15px", marginTop: "-7px" }}
                  >
                    Parent
                  </Typography>
                </Button>
              </Grid>

              {/* Teacher Button */}
              <Grid item xs={6} sm={3}>
                <Button
                  className={`${classes.teacherButton} ${roleValue === "TEACHER" ? "selected" : ""
                    }`}
                  onClick={() => handleRoleClick("TEACHER")}
                  data-testid="login-role-TEACHER"
                >
                  <Box className={classes.icon}>
                    <img
                      src="/images/Teacher icon.svg"
                      alt="Teacher Icon"
                      className={classes.iconImage}
                    />
                  </Box>
                  <Typography
                    variant="body1"
                    style={{ color: "black", fontSize: "15px", marginTop: "-7px" }}
                  >
                    Teacher
                  </Typography>
                </Button>
              </Grid>

              {/* School Button */}
              <Grid item xs={6} sm={3}>
                <Button
                  className={`${classes.studentButton} ${roleValue === "SCHOOLE" ? "selected" : ""
                    }`}
                  onClick={() => handleRoleClick("SCHOOLE")}
                  data-testid="login-role-SCHOOLE"
                >
                  <Box className={classes.icon}>
                    <img
                      src="/images/Admin icon.svg"
                      alt="School Icon"
                      className={classes.iconImage}
                      style={{ width: "16px" }}
                    />
                  </Box>
                  <Typography
                    variant="body1"
                    style={{ color: "black", fontSize: "15px", marginTop: "-7px" }}
                  >
                    School
                  </Typography>
                </Button>
              </Grid>

              {/* Admin Button */}
              <Grid item xs={6} sm={3}>
                <Button
                  className={`${classes.teacherButton} ${roleValue === "SUPERADMIN" ? "selected" : ""
                    }`}
                  onClick={() => handleRoleClick("SUPERADMIN")}
                  data-testid="login-role-SUPERADMIN"
                >
                  <Box className={classes.icon}>
                    <ChildCareSharp />
                  </Box>
                  <Typography
                    variant="body1"
                    style={{ color: "black", fontSize: "15px", marginTop: "-7px" }}
                  >
                    Srshta
                  </Typography>
                </Button>
              </Grid>
            </Grid>

            {/* Login Fields */}
            <TextField
              id="email"
              variant="outlined"
              value={loginValue}
              onChange={(e) => setLoginValue(e.target.value)}
              margin="normal"
              placeholder="Mobile number (Login Name)"
              type="email"
              fullWidth
              autoComplete="off"
              inputProps={{ 'data-testid': 'login-email' }}
            />

            <TextField
              id="password"
              variant="outlined"
              value={passwordValue}
              onChange={(e) => setPasswordValue(e.target.value)}
              margin="normal"
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              fullWidth
              autoComplete="off"
              inputProps={{ 'data-testid': 'login-password' }}
              InputProps={{

                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />

            {roleValue === "PARENT" && !parentConsentAlreadyGiven ? (
              <Box className={classes.consentBox}>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={parentConsentAccepted}
                      onChange={(e) => setParentConsentAccepted(e.target.checked)}
                      name="parentConsent"
                      disabled={parentConsentStatusLoading}
                    />
                  }
                  label={
                    <Typography className={classes.consentLabel} component="span">
                      I agree to the{" "}
                      <Link
                        href="#/montessori/term"
                        target="_blank"
                        rel="noopener noreferrer"
                        underline="always"
                      >
                        Terms &amp; Conditions
                      </Link>{" "}
                      and{" "}
                      <Link
                        href="#/montessori/privacy"
                        target="_blank"
                        rel="noopener noreferrer"
                        underline="always"
                      >
                        Privacy Policy
                      </Link>
                      .
                    </Typography>
                  }
                />
              </Box>
            ) : null}
            {roleValue === "PARENT" && parentConsentAlreadyGiven ? (
              <Typography
                variant="caption"
                style={{ display: "block", marginTop: 8, color: "#1a9b54" }}
              >
                Parent app consent already on file for this username.
              </Typography>
            ) : null}

            {/* Login Buttons */}
            <div className={classes.formButtons}>
              {isLoading ? (
                <CircularProgress size={26} className={classes.loginLoader} />
              ) : (
                <Button
                  data-testid="login-submit"
                  disabled={
                    loginValue.length === 0 ||
                    passwordValue.length === 0 ||
                    (roleValue === "PARENT" &&
                      !parentConsentAlreadyGiven &&
                      !parentConsentAccepted) ||
                    (roleValue === "PARENT" && parentConsentStatusLoading)
                  }

                  onClick={() =>
                    loginUser(
                      userDispatch,
                      loginValue,
                      passwordValue,
                      props.history,
                      setIsLoading,
                      setError,
                      roleValue,
                      handlePasswordChangeConfirm,
                      {
                        parentConsentAccepted:
                          roleValue === "PARENT" &&
                          (parentConsentAlreadyGiven || parentConsentAccepted),
                        onParentDataAcknowledgementRequired: openParentAcknowledgement,
                      },
                    )
                  }
                  variant="contained"
                  color="primary"
                  size="large"
                  fullWidth
                  style={{ backgroundColor: '#0f3b62', color: "white" }}
                >
                  Login
                </Button>
              )}

              {canForgotPassword ? (
                <Button
                  color="primary"
                  size="large"
                  style={{ fontWeight: "bold", fontSize: "smaller" }}
                  className={classes.forgetButton}
                  onClick={() => {
                    setOtpDialogOpen(true);
                    setOtpSent(false);
                    setMobile("");
                    setOtp("");
                    setNewPassword("");
                  }}
                >
                  Forgot Password?
                </Button>
              ) : null}
            </div>

            {/* OTP Dialog */}
            <Dialog
              open={otpDialogOpen}
              onClose={() => setOtpDialogOpen(false)}
              style={{ margin: "50px" }}
              PaperProps={{
                style: { width: "350px" }, // Set desired width
              }}
            >
              <DialogTitle style={{ fontSize: "smaller" }}>{forgotPasswordRoleLabel} — Forgot Password</DialogTitle>
              <DialogContent>
                <TextField
                  label="Enter Registered Mobile Number "
                  variant="outlined"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  fullWidth
                  margin="normal"
                  disabled={otpSent}
                />

                {otpSent && (
                  <>
                    <TextField
                      label="Enter OTP"
                      variant="outlined"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      fullWidth
                      margin="normal"
                    />
                    <TextField
                      label="New Password"
                      type="password"
                      variant="outlined"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      fullWidth
                      margin="normal"
                    />

                    {/* Update Password Button */}
                    <Button
                      variant="contained"
                      onClick={handleUpdatePassword}
                      fullWidth
                      style={{ marginTop: 16, backgroundColor: "rgb(15, 59, 98)" }}
                    >
                      Update Password
                    </Button>

                    {/* Resend OTP Section */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mt: 2,
                      }}
                    >
                      <Button variant="text" onClick={handleResendOtp} disabled={!resendEnabled}>
                        Resend OTP
                      </Button>
                      {!resendEnabled && (
                        <Typography variant="body2" color="textSecondary">
                          Resend available in {timer} sec
                        </Typography>
                      )}
                    </Box>
                  </>
                )}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOtpDialogOpen(false)} color="secondary">
                  Cancel
                </Button>
                {!otpSent && (
                  <Button variant="contained" color="primary" onClick={handleSendOtp}>
                    Send OTP
                  </Button>
                )}
              </DialogActions>
            </Dialog>
          </Grid>
          <Dialog
            open={otpDialogOpenReset}
            onClose={() => setOtpDialogOpenReset(false)}
            style={{ margin: "50px" }}
            PaperProps={{
              style: { width: "350px" }, // Set desired width
            }}
          >
            <DialogTitle style={{ fontSize: "smaller" }}>Reset Password</DialogTitle>
            <DialogContent>



              <>
                {/* <TextField
                      label="Mobile"
                       type="text"
                      variant="outlined"
                      // value={oldPasswordReset}
                      // onChange={(e) => setOldPasswordReset(e.target.value)}
                      fullWidth
                      margin="normal"
                    />
                    <TextField
                      label="Update Password"
                                            variant="outlined"
                      // value={newPasswordReset}
                      // onChange={(e) => setNewPasswordReset(e.target.value)}
                      fullWidth
                      margin="normal"
                    /> */}

                {/* Update Password Button */}
                <TextField
                  label="Password"
                  variant="outlined"
                  type={showPassword ? "text" : "password"}
                  fullWidth
                  value={password}
                  onChange={handlePasswordChange}
                  margin="normal"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)}>
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  label="Confirm Password"
                  variant="outlined"
                  type={showConfirmPassword ? "text" : "password"}
                  fullWidth
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                  margin="normal"
                  error={!!error}
                  helperText={error}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                          {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleUpdatePasswordReset}
                  fullWidth
                  style={{ marginTop: 16 }}
                >
                  Update Password
                </Button>

                {/* Resend OTP Section */}
                {/* <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mt: 2,
                      }}
                    >
                      <Button variant="text" onClick={handleResendOtp} disabled={!resendEnabled}>
                        Resend OTP
                      </Button>
                      {!resendEnabled && (
                        <Typography variant="body2" color="textSecondary">
                          Resend available in {timer} sec
                        </Typography>
                      )}
                    </Box> */}
              </>

            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOtpDialogOpenReset(false)} color="secondary">
                Cancel
              </Button>
              {/* {!otpSent && (
                  <Button variant="contained" color="primary" onClick={handleSendOtp}>
                    Send OTP
                  </Button>
                )} */}
            </DialogActions>
          </Dialog>

          <Dialog
            open={ackDialogOpen}
            onClose={() => {}}
            disableBackdropClick
            PaperProps={{ style: { width: "420px", maxWidth: "95vw" } }}
          >
            <DialogTitle style={{ fontSize: "1rem", fontWeight: 700, color: "#0f2d4d" }}>
              Student data acknowledgement
            </DialogTitle>
            <DialogContent>
              <Typography variant="body2" style={{ color: "#46566b", marginBottom: 12 }}>
                Before you can view your student&apos;s complete data in Montestory, please
                acknowledge that you understand and agree to access this information as the
                registered parent/guardian.
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={ackChecked}
                    onChange={(e) => setAckChecked(e.target.checked)}
                    name="parentDataAck"
                  />
                }
                label={
                  <Typography className={classes.consentLabel} component="span">
                    I acknowledge that I am the parent/guardian and may access my student&apos;s
                    complete profile and activity data.
                  </Typography>
                }
              />
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                disabled={!ackChecked || ackSaving}
                onClick={handleParentAcknowledgementContinue}
                style={{ backgroundColor: "#0f3b62" }}
              >
                {ackSaving ? "Saving…" : "Continue"}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Right Side - Illustration */}
          <Grid item xs={12} md={6} style={{ textAlign: "center", backgroundColor: "transparent" }} >
            <div>
              {/* <div className="illustration"> */}
              <img
                src="/images/hero.png"
                alt="Kids Illustration"
                style={{ maxWidth: "100%", height: "400px", width: "420px", borderRadius: "10px" }}
              />
              {/* <h3>Learning Made Fun!</h3>
                <p>Join our vibrant community of learners, parents, and teachers!</p> */}
            </div>
            {/* </div> */}
          </Grid>
        </Grid>
      </Box>

      {/* "How Montestory Works" Section */}
      {/* <Container sx={{ py: 8 }}>
        <br></br>
        <br></br>
        <Typography variant="h4" align="center" gutterBottom>
          How Montestory Works
        </Typography>
        <br></br>
        <Grid container spacing={4} sx={{ mt: 4 }}>
        
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                textAlign: "center",
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  backgroundColor: "#FFEACF",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
                <Typography variant="h6" color="primary">
                  1
                </Typography>
              </Box>
              <Typography variant="h6" gutterBottom>
                Register Your School
              </Typography>
              <Typography variant="body2">
                Create an account and set up your school profile.
              </Typography>
            </Box>
          </Grid>

       
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                textAlign: "center",
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  backgroundColor: "#D6F7D9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
                <Typography variant="h6" color="primary">
                  2
                </Typography>
              </Box>
              <Typography variant="h6" gutterBottom>
                Add Teachers & Students
              </Typography>
              <Typography variant="body2">
                Manage classroom details and student information.
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box
              sx={{
                textAlign: "center",
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  backgroundColor: "#CDE6FF",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
                <Typography variant="h6" color="primary">
                  3
                </Typography>
              </Box>
              <Typography variant="h6" gutterBottom>
                Track Progress
              </Typography>
              <Typography variant="body2">
                Monitor activities and communicate with parents.
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <br></br>
        <br></br>
      
        <Typography variant="h4" align="center" sx={{ mt: 8 }} gutterBottom>
          Featured Tools
        </Typography>
        <br></br>

        <Grid container spacing={4} sx={{ mt: 4 }}>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
                height: "100%",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: 6,
                },
              }}
            >
              <img
                src="/images/i.svg"
                alt="Weekly Planner"
                style={{ width: "25px", marginBottom: "8px" }}
              />
              <Typography variant="h6" gutterBottom>
                Weekly Planner
              </Typography>
              <Typography variant="body2">
                Weekly planner is a tool used by teachers to plan and track each student's activities and progress throughout the week. It helps ensure that children are working across all areas—like language, math, and practical life—at their own pace, while still meeting learning goals.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
                height: "100%",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: 6,
                },
              }}
            >
              <img
                src="/images/svg.svg"
                alt="Activities"
                style={{ width: "25px", marginBottom: "8px" }}
              />
              <Typography variant="h6" gutterBottom>
                Activities
              </Typography>
              <Typography variant="body2">
                In Montessori education, “activities” are hands-on tasks that help children build skills. They are chosen based on the child’s age and development. The app records each activity a student does and how well they did it.

              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
                height: "100%",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: 6,
                },
              }}            >
              <img src="/images/assignment.png" alt="Assignments" style={{ width: "25px", marginBottom: "8px" }} />
              <Typography variant="h6" gutterBottom >
                Assignments
              </Typography>
              <Typography variant="body2">
                In Montessori, assignments are activities chosen for each child based on their level and interests. This app helps parents see which assignments are given and which ones their child has completed. Option for resubmission.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
                height: "100%",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: 6,
                },
              }}            >
              <img src="/images/Charts sounds.png" alt="Charts – Sounds" style={{ width: "25px", marginBottom: "8px" }} />
              <Typography variant="h6" gutterBottom>
                Charts – Sounds
              </Typography>
              <Typography variant="body2">
                In Montessori education, 'sounds' mean the phonetic sounds of letters, not their names. This is important for early reading and writing. The tool helps track which sounds each student has practiced and plan the next ones to learn.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
                height: "100%",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: 6,
                },
              }}             >
              <img src="/images/Movable Alphabets.png" alt="Movable Alphabets" style={{ width: "25px", marginBottom: "8px" }} />
              <Typography variant="h6" gutterBottom>
                Charts – Movable Alphabets
              </Typography>
              <Typography variant="body2">
                The Movable Alphabet is a hands-on tool that helps children learn to write and spell before they can use a pencil. It helps teachers track which words each child has learned and plan what to teach next.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
                height: "100%",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: 6,
                },
              }}             >
              <img src="/images/Reports.png" alt="Reports" style={{ width: "25px", marginBottom: "8px" }} />
              <Typography variant="h6" gutterBottom>
                Reports
              </Typography>
              <Typography variant="body2">
                Report consists of progress, activities, and development in key areas, along with attendance, teacher notes and school observations.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
                height: "100%",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: 6,
                },
              }}             >
              <img src="/images/material-symbols_play-lesson.png" alt="Lesson Plans" style={{ width: "25px", marginBottom: "8px" }} />
              <Typography variant="h6" gutterBottom>
                Lesson Plans
              </Typography>
              <Typography variant="body2">
                Pre-designed lesson plans include objectives, materials, procedures, and key points of interest, helping teachers prepare more effectively and deliver lessons with all necessary resources at hand.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
                height: "100%",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: 6,
                },
              }}            >
              <img src="/images/Calendar of events.png" alt="Calendar of Events" style={{ width: "25px", marginBottom: "8px" }} />
              <Typography variant="h6" gutterBottom>
                Calendar of Events
              </Typography>
              <Typography variant="body2">
                The Calendar of Events provides a clear view of key school activities and dates, helping teachers, students, and educators stay informed throughout the year.
              </Typography>
            </Box>
          </Grid>


          <Grid item xs={12} md={4}>
            <Box
              sx={{
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
                height: "100%",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: 6,
                },
              }}
            >
              <img
                src={require("../images/Student Details.png")}
                alt="Kids Own Stories"
                style={{ width: "25px", marginBottom: "8px" }}
              />
              <Typography variant="h6" gutterBottom style={{ color: "red" }}>
                Kids Own Stories
              </Typography>
              <Typography variant="body2" style={{ color: "red" }}>
                <ul style={{ paddingLeft: "20px", margin: 0 }}>
                  <li>AI-Driven Interest Mapping & Career Matching</li>
                  <li>Adaptive Learning Pathways & Content Suggestions</li>
                  <li>Educator Dashboards & Progress Analytics</li>
                  <li>Parent Engagement Tools & Real-Time Update</li>
                  <li>Cloud-Based & Scalable for Institutions</li>
                </ul>
              </Typography>
            </Box>
          </Grid>






        </Grid>
      </Container> */}

      {/* Footer */}
      {/* <Box
        component="footer" style={{ marginTop: "3rem" }}
        sx={{
          backgroundColor: "#0D3B66",
          color: "#fff",
          pt: 4,
          pb: 2,
          width: "100%",
        }}
      >

        <Container maxWidth="lg">
          <Grid container spacing={4}>
            <Grid item xs={12} md={3}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <img
                  src="https://artistimages.blob.core.windows.net/montestory/logo 2.svg"
                  alt="Logo"
                  style={{ width: "85px" }}
                />
              </Box>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                Smart school management for young learners
              </Typography>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="h6" sx={{ mb: 2, fontSize: "1rem" }}>
                Quick Links
              </Typography>
              <br></br>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Link href="#/montessori/home" underline="hover" color="inherit">
                  Home
                </Link>
                <Link href="#/montessori/schoolregistration" underline="hover" color="inherit">
                  School Registration
                </Link>
                <Link href="#/montessori/login" underline="hover" color="inherit">
                  Login
                </Link>
                
                <br></br>
                <div className="pt-3">
                  <h4 className="uppercase text-xs font-semibold text-gray-300">Download From</h4>
                  <div className="flex space-x-4 mt-2">
                    <a href="#" aria-label="App Store">
                      <img
                        src="/images/apple logo.svg"
                        alt="Parent Icon"
                        className={classes.iconImage}
                        style={{marginRight:'15px'}}
                        
                      />
                    </a>
                    <a href="#" aria-label="Play Store">
                      <img
                      
                        src="/images/android logo.svg"
                        alt="Parent Icon"
                        className={classes.iconImage}
                      />            </a>
                  </div>
                </div>

              </Box>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="h6" sx={{ mb: 2, fontSize: "1rem" }}>
                Support
              </Typography>
              <br></br>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Link href="#/montessori/privacy" underline="hover" color="inherit">
                  Privacy Policy
                </Link>
                <Link href="#/montessori/refund-cancellation" underline="hover" color="inherit">
                  Refund and Cancellation Policy
                </Link>
                <Link href="#/montessori/term" underline="hover" color="inherit">
                  Terms of Service
                </Link>
              </Box>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="h6" sx={{ mb: 2, fontSize: "1rem" }}>
                Contact
              </Typography>
              <br></br>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <EmailIcon sx={{ mr: 1 }} />
                <Link href={`mailto:${supportEmail}`} underline="hover" color="inherit">
                  <Typography variant="body2">{supportEmail}</Typography>
                </Link>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <PhoneIcon sx={{ mr: 1 }} />
                <Typography variant="body2">+91 8247625893</Typography>
              </Box>
              <Box sx={{ mt: 1.5, maxWidth: 280 }}>
                <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
                  4-9-197, St no 7, HMT Nagar, Hyderabad 500076
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Box
            sx={{
              borderTop: "1px solid rgba(255, 255, 255, 0.2)",
              mt: 4,
              pt: 2,
              textAlign: "center",
            }}
          >
            <Typography variant="body2" sx={{ opacity: 0.7 }}>
              © 2025 Montestory. All rights reserved.
            </Typography>
          </Box>
        </Container>
      </Box> */}
    </Grid>
  );
}

export default withRouter(Login);
